import { useState } from 'react';
import toast from 'react-hot-toast';
import { Bell, Loader2, X } from 'lucide-react';

import { enablePush, pushState, type PushState } from '@/lib/push';

const PUSH_DISMISS_KEY = 'resstro-manager-push-hint:v1';

/** Полоска над лентой, пока уведомления можно включить: место в чате дороже карточки. */
export default function PushHint() {
  const [state, setState] = useState<PushState>(() => pushState());
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(PUSH_DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [busy, setBusy] = useState(false);
  const [unavailable, setUnavailable] = useState(false);

  if (dismissed || unavailable || state === 'granted' || state === 'unsupported') return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(PUSH_DISMISS_KEY, '1');
    } catch {
      /* приватный режим — подсказка вернётся при следующем входе */
    }
  };

  const enable = async () => {
    setBusy(true);
    try {
      const res = await enablePush();
      if (res === 'unavailable') setUnavailable(true);
      else setState(res);
      if (res === 'granted') toast.success('Уведомления включены');
    } catch {
      toast.error('Не удалось включить уведомления');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex shrink-0 items-center gap-2.5 border-b border-line/70 bg-white px-3 py-2 text-[13px] leading-snug sm:px-5">
      <Bell size={16} className="shrink-0 text-orange" aria-hidden />
      <div className="min-w-0 flex-1 text-ink/70">
        {state === 'ios-install'
          ? 'Чтобы приходили уведомления, добавьте кабинет на экран «Домой» и откройте оттуда'
          : state === 'denied'
            ? 'Уведомления запрещены — разрешите их для manager.resstro.ru в настройках браузера'
            : 'Включите уведомления — не пропустите сообщения команды'}
      </div>
      {state !== 'ios-install' && state !== 'denied' ? (
        <button
          type="button"
          className="inline-flex shrink-0 items-center gap-1 rounded-full bg-orange px-3 py-1.5 text-xs font-medium text-white disabled:opacity-60"
          onClick={() => void enable()}
          disabled={busy}
        >
          {busy ? <Loader2 size={13} className="animate-spin" aria-hidden /> : null}
          Включить
        </button>
      ) : null}
      <button
        type="button"
        className="shrink-0 rounded-full p-1.5 text-ink/40 hover:bg-ink/5 hover:text-ink"
        onClick={dismiss}
        aria-label="Скрыть подсказку"
      >
        <X size={15} aria-hidden />
      </button>
    </div>
  );
}
